<template>
    <div class="contract">
        <div v-if="$route.query.isApp == 1 && $route.query.isBanner == 0">
            <div v-if="!isLoading && linkType != 3" class="contract-header">
                <div><i @click.stop="goBack" class="iconfont icon-xiangyou" :class="[isDirection ? '' : 'mirrorRotateLevel']"></i></div>
            </div>
            <div v-if="$route.query.isBanner == 0 && !isLoading" class="contract-header">
                <div><i @click.stop="goBack" class="iconfont icon-xiangyou" :class="[isDirection ? '' : 'mirrorRotateLevel']"></i></div>
            </div>
        </div>
        <!-- <div class="contract-header">
            <div><i @click.stop="goBack" class="iconfont icon-xiangyou" :class="[isDirection ? '' : 'mirrorRotateLevel']"></i></div>
        </div> -->
        <div class="scroll-box" :class="isHeader">
            <InCompleteSiteHead v-if="this.$route.query.isApp != 1" class="InCompleteSiteHead" />
            <div class="header">
                <div class="model1">
                    {{resultObj.title}}
                </div>
                <div class="model2">
                    <div class="model2_text">
                        <!-- 距离活动结束 -->
                        {{$t('9100080')}}
                    </div>
                    <div>
                        <tradeCompetition :end-time="resultObj.endTime" type="2"></tradeCompetition>
                    </div>
                </div>
                <div class="model3">
                    <div class="model3_box">
                        <img :src=resultObj.h5Img>
                    </div>
                    
                    <!-- <van-image :src="resultObj.h5Img">
                        <template v-slot:error>
                            
                        </template>
                    </van-image> -->
                </div>
                <div :class="changeApplication" @click="toApplication">{{textVar}}</div>

                <div class="model4">
                    <!-- 點選「報名參加」贏大獎 -->
                    <div>{{$t('9100081')}}</div>
                    <span @click="goRuler">
                        <!-- 查看规则 -->
                        {{$t('9100082')}}
                    </span>
                </div>
                <div class="model5" @click="goShareUrl">
                    <img src="../assets/images/fenxiang.svg">
                    <!-- 分享 -->
                    {{$t('300342')}}
                </div>
            </div>
            <div class="mainBody">
                <div class="mainBody-content">
                    <div v-for="(item,index) in subResultArray" :key="index">
                        <div class="content_title" :class="{ 'no-margin-top': index === 0 }">
                            <div class="left_line"></div>
                            <!-- 活动 -->
                            <div class="center_text">{{$t('9100084')}}<span>{{index+ 1}}</span></div>
                            <div class="right_line"></div>
                        </div>
                        <div class="content_content">
                            <div class="content_content-left">
                                <div class="title">{{item.title}}</div>
                                <p v-html="item.rule"></p>
                                <div v-if="item.h5Img" class="actImg">
                                    <img :src=item.h5Img>
                                </div>
                            </div>
                            <div class="content_content-right" @click="toUrl(item)">
                                <div class="toTrade">{{changeText(item)}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="returnPro" v-if="!$route.query.isApp">
                    <div class="returnPro-test" @click.stop="goBack">
                        {{$t('300358')}}
                        <img src="../assets/images/returnPro.svg">
                    </div>
                </div>
                <div class="mainBody-ruler1"></div>
                <div class="mainBody-ruler">
                    <div class="ruler_title">
                        <!-- 活动规则 -->
                        {{$t('300140')}}
                    </div>
                    <!-- <div class="ruler_details">活动说明</div> -->
                    <p v-html="resultObj.rule"></p>
                </div>
            </div>
        </div>
        <!-- 分享 -->
        <div class="purchase_toast" v-if="buySuccessShare">
            <div class="shareBox">
                <img src="../assets/images/xuanZhong111.png">
                <p class="boldShare">{{$t('300027')}}</p>
            </div>
        </div>
        <!--参与报名成功-->
        <van-popup v-model="sucPoint" class="tip-popup" :style="{ width: '15.6rem',padding: '1.2rem' }" round>
            <div>
                <svg slot="image" class="icon boxIcon" aria-hidden="true">
                    <use xlink:href="#icon-tishi-1"></use>
                </svg>
                <!-- signUpMsg -->
                <p>{{$t('9100028')}}</p>
                <van-button class="confirmBtn" @click="sucPoint = false">
                    <!-- 好的 -->
                    {{$t('300141')}}
                </van-button>
            </div>
        </van-popup>
        <!-- 活动没开始 -->
        <van-popup v-model="noStartTip" class="tip-popup" :style="{ width: '15.6rem',padding: '1.2rem' }" round>
            <div>
                <svg slot="image" class="icon boxIcon" aria-hidden="true">
                    <use xlink:href="#icon-tishi-1"></use>
                </svg>
                <!-- signUpMsg -->
                <p>{{signUpMsg}}</p>
                <van-button class="confirmBtn" @click="noStartTip = false">
                    <!-- 好的 -->
                    {{$t('300141')}}
                </van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import { Button, Toast,Image } from 'vant'
    import { mainActivity, subActivity, application, findUserOperation } from '../api/hotCoin.js'
    import tradeCompetition from '../compontents/tradeCountDown.vue'
    import { mapGetters } from "vuex";
    import { getLanguageList, getUserInfo } from "../api/user";
    import { setToken } from '../utils/auth'
    import { copy } from 'fastjs-next'
    import { getBanner } from '../api/resource'
    import InCompleteSiteHead from '../compontents/newHome/InCompleteSiteHead.vue'

    import '@/assets/newCss/reset.scss'
    import '@/assets/tailwendcss.css'
    import '@/assets/uemo-icon-font/fonts/ueicon.css'
    import '@/assets/newCss/var.scss'
    //TODO:行高问题
    import '@/assets/newCss/base.scss'

    export default {
        components: {
            VanButton: Button,
            tradeCompetition,
            InCompleteSiteHead,
            VanImage:Image,
        },
        data() {
            return {
                istrue: '',
                uniqueIdentification: '',
                config: {},
                userInfo: {},
                languageName: '',
                cftj: false,
                isLoading: true,
                isiOS: '',
                resultObj: {},
                subResultArray: [],
                isNoTime: false,
                changeApplication: '',
                buySuccessShare: false,
                endTimer: '',
                sucPoint: false,
                noStartTip: false,
                signUpMsg: '',
                isHeader: '',
                linkType: '',
                // textVar: this.$t('9100083'), //报名
                textVar: '',
            }
        },
        computed: {
            ...mapGetters(['token', 'user', 'language', 'isApp', 'isDirection'])
        },
        created() {
            console.log(this.$route.path, 'this.$route.path')
            console.log(this.$route.query, 'this.$route.query')
            this.getGetBanner()
            var u = navigator.userAgent;
            // this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (this.$route.query.backgroundColor != '') {
                window.document.documentElement.setAttribute(
                    'data-theme',
                    this.$route.query.backgroundColor === 'day' ? 'sunlight' : 'moon'
                )
            }
            this.istrue = ''
            let langugage = this.$route.query.language || this.language;
            console.log(this.$route.query.language, 'this.$route.query.language');
            this.$store.dispatch('setLanguage', langugage)
            getLanguageList().then(res => {
                let el = res.data.find(item => {
                    return item.language == this.$route.query.language
                })
                // this.$store.dispatch('setLanguageName', el.name)
                if (this.$route.query.isApp == 1) {
                    this.$i18n.locale = this.$route.query.language
                }
                this.$store.dispatch(
                    "setIsDirection",
                    this.$route.query.language == "fa" || this.language == 'fa' ? true : false
                );
                window.document.documentElement.setAttribute(
                    "dir",
                    this.isDirection ? "rtl" : "ltr"
                );
            })

            this.resher()
            this.getMainActivity()
            this.startTimer()
            if (this.$route.query.isApp == 1 && this.$route.query.isBanner != 0) {
                console.log(this.linkType, 'this.linkType')
                this.isHeader = 'isHeader'
            }
        },
        watch: {
            $route() {
                this.resher()
            },
        },
        methods: {
            setStart() {
                let timer = null
                let isGet = false
                const innerFn = () => {
                    this.currentTimeStamp = Date.now()
                    // console.log(
                    //     this.currentTimeStamp,
                    //     '当前的时间戳currentTimeStamp'
                    // )
                    if (this.currentTimeStamp < this.resultObj.startTime) {
                        console.log('现在是未开始')
                        this.textVar = this.$t('9000026') //未开始
                        this.changeApplication = 'noCanApplication'
                    } else if (
                        this.currentTimeStamp >= this.resultObj.startTime &&
                        this.currentTimeStamp <= this.resultObj.endTime
                    ) {
                        if (!isGet) {
                            this.textVar = this.$t('9100083') //报名参加
                            this.changeApplication = 'canApplication'
                        }
                        if (this.$route.query.token || this.token && !isGet) {
                            let token = this.$route.query.token || this.token
                            getUserInfo(token).then(res => {
                                this.userInfo = res.data
                                findUserOperation({ customId: this.$route.query.id, userId: res.data.id }).then(res => {
                                    if (res.data == false) {
                                        this.textVar = this.$t('9100083') //报名
                                        this.changeApplication = 'canApplication'
                                    } else {
                                        this.textVar = this.$t('300353') //已报名
                                        this.changeApplication = 'noCanApplication'
                                    }
                                })
                            })
                        }
                        // else{
                        //     this.textVar = this.$t('9100083') //报名
                        //     this.changeApplication = 'canApplication'
                        // }
                        isGet = true
                        // console.log(isGet,'isGet后面');
                    } else {
                        // console.log('现在是已结束')
                        this.textVar = this.$t('9000021') //已结束
                        this.changeApplication = 'noCanApplication'
                        clearInterval(timer)
                    }
                }
                innerFn();
                timer = setInterval(innerFn, 1000)
            },
            getGetBanner() {
                getBanner({ type: 2 })
                    .then((res) => {
                        if (res.code === 200) {
                            this.bannerList = res.data
                            console.log(this.bannerList, 'bannerList==========')
                            const anniversaryBanner = res.data.find((item) =>
                                item.link.includes('/tradeCompetition')
                            )
                            if (anniversaryBanner) {
                                this.linkType = anniversaryBanner.linkType
                            }
                        }
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
            goShareUrl() { 
                if(this.$route.query.isApp!=1){
                posthog.capture('Button Clicked', {
                trigger:'h5_activity_page_sodi_airdrop_share_button',
                name:'活动页面-SODI空投-分享按钮-H5',
                channel_url:sessionStorage.getItem('channelUrl') || '',
                });
                }else{
                this.$jsBridge.callHandler(
                    this.$jsBridgeCmd.segmentReport,
                {data:{
                url: window.location.href.toString().split('?')[0] + `?id=${this.$route.query.id}`,
                trigger:'h5_activity_page_sodi_airdrop_share_button',
                name:'活动页面-SODI空投-分享按钮-H5',
                channel_url:sessionStorage.getItem('channelUrl') || '',
                }},
                (data) => {}
                )
                }
                const url = window.location.href;
                const index = url.indexOf('/tradeCompetition');
                const substring = url.substring(0, index);
                console.log(substring,'substring-substring');
                const shareUrl = `${substring}/tradeCompetition?id=${this.$route.query.id}`;
                copy(shareUrl)
                this.buySuccessShare = true
                let timer = setTimeout(() => {
                    this.buySuccessShare = false
                    clearTimeout(timer)
                }, 2000)
            },
            toUrl(item) {
                if(this.$route.query.isApp!=1){
                posthog.capture('Button Clicked', {
                trigger:'h5_activity_page_sodi_airdrop_trade_button',
                name:'活动页面-SODI空投-交易按钮-H5',
                channel_url:sessionStorage.getItem('channelUrl') || '',
                activity_info:item
                });
                }else{
                this.$jsBridge.callHandler(
                    this.$jsBridgeCmd.segmentReport,
                    {data:{
                    url: window.location.href.toString().split('?')[0] + `?id=${this.$route.query.id}`,
                    trigger:'h5_activity_page_sodi_airdrop_trade_button',
                    name:'活动页面-SODI空投-交易按钮-H5',
                    channel_url:sessionStorage.getItem('channelUrl') || '',
                    activity_info:item
                }},
                (data) => {}
                )
                }
                let banner = this.$route.query.isBanner == 1 ? '&isBanner=1' : '&isBanner=0'
                console.log(item.url);
                // console.log(item.url.split("/")[2]);
                if (item.url.includes('chargemoney')) {
                    if (this.$route.query.isApp) {
                        if (this.$route.query.token || this.token) {
                            this.$jsBridge.callHandler(
                                this.$jsBridgeCmd.appRecharge,
                                {
                                    code: 200,
                                    active: window.location.origin + `/tradeCompetition?id=${this.$route.query.id}${banner}`
                                },
                                data => { }
                            );
                        } else {
                            this.appLogin()
                        }
                    } else {
                        if (this.token) {
                            this.$router.push('/newIndex')
                        } else {
                            this.appLogin()
                        }
                    }
                } else if (item.url.includes('trade')) {
                    const symbolUrl = item.url.split("/")[2]
                    // if (this.$route.query.isApp) {
                    //     console.log('去现货交易');
                    //     this.$jsBridge.callHandler(this.$jsBridgeCmd.appSpot, { code: 200, symbol: symbolUrl }, (data) => {
                    //     })
                    // } else {
                    //     this.$router.push('/newIndex')
                    // }
                    if (this.$route.query.isApp) {
                        if (this.$route.query.token || this.token) {
                            console.log('去现货交易');
                            this.$jsBridge.callHandler(this.$jsBridgeCmd.appSpot, { code: 200, symbol: symbolUrl }, (data) => {
                            })
                        } else {
                            this.appLogin()
                        }
                    } else {
                        if (this.token) {
                            this.$router.push('/newIndex')
                        } else {
                            this.appLogin()
                        }
                    }
                }
            },
            toApplication() {
                if (this.cftj) return;
                this.cftj = true;

                if (this.$route.query.token || this.token) {
                    application({
                        customId: this.$route.query.id,
                        userId: this.userInfo.id,
                    })
                        .then((res) => {
                            console.log(res, '看看报名后的res')
                            this.textVar = this.$t('300353') //已报名
                            this.changeApplication = 'noCanApplication' 
                            this.signUpMsg = res.msg
                            this.sucPoint = true
                            // let token = this.$route.query.token || this.token
                            // getUserInfo(token).then(res => {
                            //     this.userInfo = res.data
                            //     findUserOperation({ customId: this.$route.query.id, userId: res.data.id }).then(res => {
                            //         // this.istrue = res.data
                            //         console.log(res.data, 'res.data');
                            //     })
                            // })
            if(this.$route.query.isApp!=1){
                posthog.capture('Button Clicked', {
                trigger:'h5_activity_page_sodi_airdrop_join_button',
                name:'活动页面-SODI空投-报名按钮-H5',
                channel_url:sessionStorage.getItem('channelUrl') || '',
                });
                }else{
                this.$jsBridge.callHandler(
                    this.$jsBridgeCmd.segmentReport,
                    {data:{
                    url: window.location.href.toString().split('?')[0] + `?id=${this.$route.query.id}`,
                    trigger:'h5_activity_page_sodi_airdrop_join_button',
                    name:'活动页面-SODI空投-报名按钮-H5',
                    channel_url:sessionStorage.getItem('channelUrl') || '',
                }},
                (data) => {}
                )
                }}).finally(() => {
                            this.cftj = false
                        })
                } else {
                    this.appLogin()
                }
            },
            getMainActivity() {
                mainActivity(this.$route.query.id).then(res => {
                    this.resultObj = res.data
                    console.log(this.resultObj.endTime, 'this.resultObj.endTime-this.resultObj.endTime');
                    this.setStart()
                    this.getSubActivity()
                })
            },
            getSubActivity() {
                subActivity(this.resultObj.id).then(res => {
                    this.subResultArray = res.data
                })
            },
            // whetherSignUp() {
            //     getUserInfo(token).then(res => {
            //         this.userInfo = res.data
            //         findUserOperation({ customId: this.$route.query.id, userId: res.data.id }).then(res => {
            //             this.istrue = res.data
            //             console.log(this.istrue, 'this.istrue-this.istrue');
            //         })
            //     })
            // },
            resher() {
                this.isApp = this.$route.query.isApp
                let token = this.$route.query.token || this.token
                if (token) {
                    setToken(token);
                    this.$store.dispatch('GetInfo', token);
                    this.$store.dispatch('setToken', token);
                    // if (this.$route.query.isApp == 1) {
                    /* getUserInfo(token).then(res => {
                        this.userInfo = res.data
                        findUserOperation({ customId: this.$route.query.id, userId: res.data.id }).then(res => {
                            if (res.data == false) {
                                this.textVar = this.$t('9100083') //报名
                                this.changeApplication = 'canApplication'
                            } else {
                                this.textVar = this.$t('300353') //已报名
                                this.changeApplication = 'noCanApplication'
                            }
                        })
                    }) */
                    // }
                }
            },
            goBack() {
                let isApp = (this.$route.query.isApp || this.isApp) ? '&isApp=1' : ''
                this.$router.push(`/activity?language=${this.language}${isApp}&backgroundColor=` + this.$route.query.backgroundColor)
            },
            appLogin() {
                let banner = this.$route.query.isBanner == 1 ? '&isBanner=1' : '&isBanner=0'
                if (this.$route.query.isApp == 1 || this.isApp == 1) {
                    this.$jsBridge.callHandler(
                        this.$jsBridgeCmd.appLogin,
                        {
                            code: 200,
                            type: "login",
                            url: window.location.href.toString().split("?")[0] + `?id=${this.$route.query.id}${banner}`
                        },
                        data => {
                        }
                    );
                } else {
                    this.$router.push({ path: '/login', query: { historyBack: `/tradeCompetition?id=${this.$route.query.id}` } });
                }
            },
            startTimer() {
                this.endTimer = setInterval(() => {
                    this.checkEndTime();
                }, 1000); // 每秒检查一次
            },
            checkEndTime() {
                // console.log(new Date().getTime());
                if (this.resultObj.endTime < new Date().getTime()) {
                    //已结束
                    this.isNoTime = true
                    clearInterval(this.endTimer);
                } else {
                    this.isNoTime = false
                }
            },
            changeText(item) {
                if (item.url.includes('chargemoney')) {
                    // 9100089 去充值
                    return this.$t('9100089')
                } else if (item.url.includes('trade')) {
                    // 9100088 去交易
                    return this.$t('9100088')
                }
            },
            goRuler() {
                if(this.$route.query.isApp!=1){
                posthog.capture('Button Clicked', {
                trigger:'h5_activity_page_sodi_airdrop_view_rule_button',
                name:'活动页面-SODI空投-查看规则按钮-H5',
                channel_url:sessionStorage.getItem('channelUrl') || '',
                });
                }else{
                this.$jsBridge.callHandler(
                    this.$jsBridgeCmd.segmentReport,
                    {data:{
                url: window.location.href.toString().split('?')[0] + `?id=${this.$route.query.id}`,
                trigger:'h5_activity_page_sodi_airdrop_view_rule_button',
                name:'活动页面-SODI空投-查看规则按钮-H5',
                channel_url:sessionStorage.getItem('channelUrl') || '',
                }},
                (data) => {}
                )
                }
                const targetElement = document.querySelector('.mainBody-ruler1')
                // 使用元素的 scrollTo 方法将窗口滚动到目标位置
                targetElement.scrollIntoView({ behavior: 'smooth' })
            },
        },
        mounted() {

        }
    }
</script>
<style lang="scss" scoped>
    @import "../assets/css/variableName";
    @import "../style/mixin";
    //正常
    [dir="ltr"] {
        // .model4 span {
        //     margin-left: torem(16);
        // }
        .model5 img {
            margin-right: torem(8);
        }
        .center_text span {
            margin-left: 8px;
        }
        .purchase_toast .boldShare {
            margin-left: torem(6);
        }
    }

    //镜像
    [dir="rtl"] {
        // .model4 span {
        //     margin-right: torem(16);
        // }
        .model5 img {
            margin-left: torem(8);
        }
        .center_text span {
            margin-right: 8px;
        }
        .purchase_toast .boldShare {
            margin-right: torem(6);
        }
    }
</style>
<style lang="scss" scoped>
    @import "../assets/css/variableName";
    @import "../style/mixin";
    @import "../assets/css/mixin";

    .contract {
        height: 100vh;
        width: 100%;
        overflow: hidden;
        position: fixed !important;
        top: 0;
        left: 0;
        box-sizing: border-box;
        // /deep/ .loading-model {
        //     background: #fff;
        //     z-index: 9999;
        // }
    }

    .contract-header {
        padding: 0 torem(16);
        width: 100%;
        box-sizing: border-box;
        height: torem(44);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: fixed;
        top: 0;
        // background-color: #ffffff;
        @include background_color("background-color-2");
        left: 0;
        z-index: 9999;
        i {
            font-size: torem(18);
            width: torem(14);
            height: torem(18);
            display: inline-block;
            @include font_color("font-color");
        }
    }
    .scroll-box {
        height: 100vh;
        overflow-y: auto;
        background-color: #ffffff;
        //margin-top: torem(44);
        padding: torem(44) 0;
        box-sizing: border-box;
        -webkit-overflow-scrolling: touch;
        .header {
            width: 100%;
            // height: torem(799);
            background: linear-gradient(
                180deg,
                #fff7db 0%,
                rgba(255, 229, 223, 0.36) 80%
            );
            padding: torem(35) torem(25) torem(48) torem(25);
            .model1 {
                color: #04091a;
                height: auto;
                font-size: torem(28);
                font-weight: 600;
                font-family: Lato-Semibold;
                line-height: normal;
            }
            .model2 {
                margin-top: torem(23);
                padding: 0 torem(13);
                .model2_text {
                    margin-bottom: torem(13);
                    color: #565d73;
                    font-family: Lato-Semibold;
                    font-size: torem(12);
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                }
            }
            .model3 {
                display: flex;
                justify-content: center;
                width: 100%;
                margin-top: torem(44);
                margin-bottom: torem(35);
                .model3_box{
                        width: torem(287);
                        height: torem(287);
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            .model4 {
                display: flex;
                text-align: center;
                flex-direction: column;
                margin-top: torem(16);
                justify-content: center;
                //font
                color: #8d93a6;
                font-family: Lato-Semibold;
                font-size: torem(13);
                font-weight: 400;
                line-height: torem(18.4);
                div {
                    // max-width: torem(200);
                }
                span {
                    color: #e96f2b;
                    font-family: Lato-Semibold;
                    font-size: torem(13);
                    font-weight: 400;
                    margin-top: torem(4);
                    // margin-left: 16px;
                }
            }
            .model5 {
                margin-top: torem(17);
                display: flex;
                justify-content: center;
                align-items: center;
                // margin-left: 18px;
                //font
                color: #e96f2b;
                font-family: Lato-Semibold;
                font-size: torem(16);
                line-height: normal;
                font-weight: 400;
                img {
                    // margin-right: 8px;
                    width: torem(20);
                    height: torem(20);
                }
            }
        }
        .mainBody {
            margin: 0 auto;
            padding: torem(45) torem(24) 0 torem(24);
            &-content {
                .content_title {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: torem(44);
                    .left_line {
                        // width: torem(110);
                        // width: 100%;
                        flex: 1;
                        height: torem(2);
                        // opacity: 0.6;
                        background: linear-gradient(
                            90deg,
                            rgba(255, 199, 43, 0) 0%,
                            #ffb72b 100%
                        );
                    }
                    .center_text {
                        // width: 100%;
                        // display: inline-block;
                        text-align: center;
                        color: #04091a;
                        font-family: Lato-Semibold;
                        font-size: torem(24);
                        font-weight: 600;
                        margin: 0 torem(16);
                        line-height: normal;
                        span {
                            // margin-left: 8px;
                        }
                    }
                    .right_line {
                        // width: torem(110);
                        // width: 100%;
                        flex: 1;
                        height: torem(2);
                        background: linear-gradient(
                            270deg,
                            rgba(255, 199, 43, 0) 0%,
                            #ffb72b 100%
                        );
                    }
                }
                .content_content {
                    margin-top: torem(32);
                    // display: flex;
                    // justify-content: space-between;
                    &-left {
                        // width: 1000px;
                        .title {
                            color: #04091a;
                            font-family: Lato-Semibold;
                            font-size: torem(20);
                            font-weight: 600;
                            margin-bottom: torem(12);
                            line-height: normal;
                            //
                            // display: -webkit-box;
                            // -webkit-box-orient: vertical;
                            // overflow: hidden;
                            // text-overflow: ellipsis;
                            // -webkit-line-clamp: 2; /* 控制最大行数 */
                            // line-height: 1.5; /* 行高，可根据需要调整 */
                        }
                        .actImg {
                            width: torem(327);
                            height: torem(164);
                            margin-top: torem(12);
                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                        p {
                            line-height: normal;
                        }
                    }
                    &-right {
                        margin-top: torem(24);
                        .toTrade {
                            // position: relative;
                            // z-index: 999;
                            width: 100%;
                            height: torem(48);
                            display: inline-flex;
                            justify-content: center;
                            align-items: center;
                            border-radius: 8px;
                            background: #ffc72b;
                            //font
                            color: #333;
                            text-align: center;
                            font-family: Lato-Semibold;
                            font-size: torem(14);
                            font-style: normal;
                            font-weight: 600;
                            line-height: torem(16); /* 115.315% */
                        }
                    }
                }
            }
            .returnPro {
                margin-top: torem(20);
                &-test {
                    // margin: 0 auto;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #e96f2b;
                    font-family: Lato-Semibold;
                    font-size: torem(14);
                    font-style: normal;
                    font-weight: 600;
                    line-height: normal;
                }
            }
            &-ruler {
                margin-top: torem(64);
                margin-bottom: torem(40);
                .ruler_title {
                    text-align: center;
                    color: #04091a;
                    font-family: Lato-Semibold;
                    font-size: torem(24);
                    font-style: normal;
                    font-weight: 600;
                    line-height: normal;
                    margin-bottom: torem(24);
                }
                .ruler_details {
                    color: #04091a;
                    font-family: Lato-Semibold;
                    font-size: torem(14);
                    font-style: normal;
                    font-weight: 600;
                    line-height: normal;
                    margin-bottom: torem(16);
                }
                p {
                    line-height: normal;
                }
            }
        }
    }
    .canApplication {
        display: flex;
        width: 100%;
        height: torem(48);
        // padding: torem(19.5) torem(96.47) torem(20.5) torem(96.66);
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: torem(8);
        background: #ffc72b;
        box-shadow: 0 torem(4) torem(20) 0 rgba(241, 247, 255, 0.15) inset;
        //font
        font-family: Lato-Semibold;
        color: #333;
        text-align: center;
        font-size: torem(14);
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .noCanApplication {
        display: flex;
        width: 100%;
        height: torem(48);
        // padding: torem(19.5) torem(96.47) torem(20.5) torem(96.66);
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: torem(8);
        background: #ccc !important;
        box-shadow: 0 torem(4) torem(20) 0 rgba(241, 247, 255, 0.15) inset;
        //font
        font-family: Lato-Semibold;
        color: #fff !important;
        text-align: center;
        font-size: torem(14);
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .isiOS {
        //height:calc(100vh - #{torem(44)})!important;
        padding-bottom: torem(120);
    }
    .no-margin-top {
        margin-top: 0px !important;
    }
    .purchase_toast {
        // padding: torem(8) 0 torem(42) 0;
        box-sizing: border-box;
        position: fixed;
        top: 50%;
        left: 50%;
        z-index: 9999;
        transform: translate(-50%, -50%);
        // width: torem(197);
        height: torem(40);
        border-radius: torem(25.5);
        background: rgba($color: #000000, $alpha: 0.8);
        .shareBox {
            display: flex;
            justify-content: center;
            align-content: center;
            margin-top: torem(8);
            padding: 0 torem(18);
        }
        img {
            width: torem(20);
            height: torem(20);
            margin-top: torem(1);
        }
        .boldShare {
            // margin-left: torem(6);
            color: #fff;
            font-size: torem(16);
            // line-height: torem(22);
            line-height: normal;
            text-align: center;
        }
    }
    .tip-popup {
        text-align: center;
        // @include background_color("background-color-8");
        background-color: #ffffff, svg {
            width: torem(33);
            height: torem(33);
        }
        p {
            // @include sc(torem(14), #333);
            line-height: 1.5;
            margin: torem(16) 0 torem(24);
            // @include font_color("font-color-3");
            color: #000922;
        }
        /deep/ .van-button {
            width: 100%;
            height: torem(44);
            // @include sc(torem(16), #333);
            // background-color: #ffc72b;
            border: none;
            border-radius: torem(4);
        }
        .cancalBtn {
            margin-top: torem(8);
            // @include background_color("background-color-9");
            background-color: #eaecef;
            // @include font_color("font-color-3");
            color: #000922;
        }
        .confirmBtn {
            background-color: #ffc72b;
        }
    }
    .boxIcon {
        width: torem(48);
        height: torem(48);
        margin: 0 auto;
    }
    .isHeader {
        padding-top: 0 !important;
    }
    /deep/ .van-image{
                 .van-image__error{
                   background: transparent;
                 }
                 .van-icon{
                    display: none !important;
                 }
               }
</style>



// WEBPACK FOOTER //
// src/view/tradeCompetition.vue